<div class="log-container">
  <div class="log-line" *ngFor="let line of logLines; let i = index">
    <!--<span class="line-number">{{ i + 1 }}</span> -->
    <span class="line-content" [innerHTML]="line"></span>
  </div>
</div>